module.exports = __webpack_public_path__ + "static/media/jose2.1f8a6321.png";